/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

export const getUrlWithRefcode = (url: string, refcode: string) => {
  const finalurl = url + `${url.includes('?') ? '&' : '?'}ref=${refcode}`;
  return finalurl;
};

export function replaceAll(
  string: string,
  stringToReplace: string,
  replaceWith: string
) {
  return string.split(stringToReplace).join(replaceWith);
}

export function sanitizeTag(tag: string) {
  tag = replaceAll(tag, '+', '-plus');
  tag = replaceAll(tag, 'c#', 'c-sharp');
  tag = replaceAll(tag, '#', 'hash');
  tag = replaceAll(tag, '.', '');
  return tag;
}

export const createUrl = (name: string, id: string | number, type: string) => {
  let category = name ? name.toLowerCase() : '';
  category = category.trim();
  category = category.replace(/[*%$&']/g, '');
  category = category.replace(/\s+/g, '-');
  category = category.replace(/\//g, '-');
  category = category.replace(/-jobs/g, '');
  category = sanitizeTag(category);
  category = category.replace(/#/g, '-hash');
  category = category.replace(/-+/g, '-');
  if (['c', 'k'].includes(type)) return `/${type}/${category}-jobs`;
  const url = `/${type}/${category}-jobs-${id}`;
  return url;
};
